<template>
  <div class="links">
    <div style="text-align: center; padding-bottom: 10px;">
      <b-button href="http://www.openaccessweek.org" target="_blank" variant="outline-primary"><span>OAWeek 官方網站</span></b-button>
      <!-- <b-button v-b-toggle.collapse-3 class="m-1" variant="outline-primary" href="#one"><span>各校OA活動</span></b-button> -->
      <!-- <b-button href="#" target="_blank" variant="outline-primary"><span>師大圖書館OA網頁</span></b-button> -->
      <b-button v-b-toggle.collapse-1 class="m-1" variant="outline-primary"><span>相關文章</span></b-button>
      <b-button href="https://youtu.be/GH-wCk0fu_A" target="_blank" variant="outline-primary"><span>Unpaywall紀錄片</span></b-button>
      <b-button v-b-toggle.collapse-2 class="m-1" variant="outline-primary"><span>108年度學術傳播與開放取用攻略研習班</span></b-button>
      <b-collapse accordion="my-accordion" id="collapse-1" style="width: 30%; margin-left: 39%;">
        <b-card>
          <b-link href="https://www.slideshare.net/clavenke/ss-178924016" target="_blank">開放取用發展趨勢</b-link>
        </b-card>
        <b-card>
          <b-link href="https://clavenke.blogspot.com/2019/06/blog-post.html" target="_blank">想一想、檢查檢查、再投稿</b-link>
        </b-card>
        <b-card>
          <b-link href="https://clavenke.blogspot.com/2019/06/blog-post_88.html" target="_blank">想一想、檢查檢查、再參加</b-link>
        </b-card>
        <b-card>
          <b-link href="http://clavenke.blogspot.com/2019/09/blog-post.html" target="_blank">掠奪性期刊判斷案例 (一)</b-link>
        </b-card>
        <b-card>
          <b-link href="http://clavenke.blogspot.com/2019/09/blog-post_12.html" target="_blank">掠奪性期刊判斷案例 (二)</b-link>
        </b-card>
        <b-card>
          <b-link href="http://clavenke.blogspot.com/2019/07/oa2020_27.html" target="_blank">OA2020是甚麼碗糕?</b-link>
        </b-card>
        <b-card>
          <b-link href="http://clavenke.blogspot.com/2019/07/oa2020_2.html" target="_blank">圖書館如何支持OA2020？</b-link>
        </b-card>
        <b-card>
          <b-link href="http://clavenke.blogspot.com/2019/07/plan-s.html" target="_blank">Plan S 與公開取用</b-link>
        </b-card>
      </b-collapse>
      <b-collapse accordion="my-accordion" id="collapse-2" style="width: 30%; margin-left: 65%;">
        <!-- <b-card>
          <b-link href="https://youtu.be/DtZ7xP7ibwU" target="_blank">數位化學術研究服務 柯皓仁教授</b-link>
        </b-card> -->
        <b-card>
          <b-link href="https://youtu.be/T3qIXVDD308" target="_blank">資訊公開取用發展趨勢 柯皓仁教授</b-link>
        </b-card>
        <!-- <b-card>
          <b-link href="https://youtu.be/1Q0tYvT-2qk" target="_blank">學術研究力之書目計量分析 洪文琪博士</b-link>
        </b-card>
        <b-card>
          <b-link href="https://youtu.be/EJDUPy0meK0" target="_blank">洞察學科布局，精準追蹤研究能量 李旻哲+官欣瑩</b-link>
        </b-card> -->
        <b-card>
          <b-link href="https://youtu.be/DEYKGb4_ZLs" target="_blank">OA推廣與最佳實務 林孟玲</b-link>
        </b-card>
      </b-collapse>
    </div>
    
        <!-- <div> -->
      <!-- <b-table responsive :items="items" :fields="fields" class="mt-3" outlined style="padding-left:15% padding-right:15%"></b-table> -->
    <!-- </div> -->
   
  
 
  
  </div>
</template>
<script>
// import { mdbBtn, mdbContainer, mdbCol, mdbRow, mdbCard, mdbCardBody } from 'mdbvue'
// import 'vue-good-table/dist/vue-good-table.css'
// import { VueGoodTable } from 'vue-good-table';
export default {
  name: 'Links',
  components: {
    // VueGoodTable,
    // VueVirtualTable
    // mdbBtn,
    // mdbContainer,
    // mdbCol,
    // mdbRow,
    // mdbCard,
    // mdbCardBody
  },
  data () {
    return {
      showCollapse: true,
      collapse2: false,
      collapse3: false,
      // columns:[
        
      //   {
      //     label:"活動名稱",
      //     field:"name",
      //   },
      //   {
      //     label:"活動時間",
      //     field:"time",
      //     type:"date",
      //   },
      //   {
      //     label:"主辦單位",
      //     field:"host",
      //   }
      // ],
      // rows:[
      //   {id:1, name:'2019開放取用週：為誰開放？公平的開放知識', time:'2019/10/21-27', host:'ntnu'},
      // ]
      // ,
      fields:[
        {
          key:'ID',
          sortable: false
        },
        {
          key:'活動名稱',
          sortable: false
        },{
          key:'活動時間',
          sortable: true
        },{
          key:'主辦單位',
          sortable: false
        }
      ],
      items:[
        {
          ID:1, 
          活動名稱:'<a href="https://subjectguide.lib.ntnu.edu.tw/2019OAweek">2019開放取用週：為誰開放？公平的開放知識</a>', 
          活動時間:'2019/10/21-27',
          主辦單位:'國立臺灣師範大學圖書館'
          },
        {
          ID:2, 
          活動名稱:'<a href="https://secure.wiley.com/CTW_Uniday">OA期刊投稿與防範掠奪期刊講座「我們與假期刊的距離」</a>', 
          活動時間:'2019/10/22',
          主辦單位:'國立中興大學圖書館'
          }
      ]
    }
  },
  methods: {
    beforeEnter (el) {
      this.elHeight = el.scrollHeight
    },
    enter (el) {
      el.style.height = this.elHeight + 'px'
    },
    beforeLeave (el) {
      el.style.height = 0
    }
  }
}

</script>
<style scoped>
.collapse-item {
  overflow: hidden;
  height: 0;
  padding: 0;
  transition: height .5s;
}
/*#collapse-1{
  position: relative;
  height: 0;
  overflow: show;
  @include transition($transition-collapse);
}*/
span {
  font-family: Microsoft JhengHei;
  font-size: 16px;
  font-weight: bold;
}
.links {
  padding-top: 20px;
  background-color: rgba(248, 194, 88,0.1);
  box-shadow: 0 5px 5px -2px rgba(0, 0, 0, .2);
  padding-bottom:400px;
}
.tb {
   
    margin-left:5%; 
    margin-right:5%; 
    background-color:white 0.5;
    border-radius:10px;
    box-shadow:0 0 5px #000;
     
}
/*.contain {

  padding-bottom:20px;
  background-color: rgba(0, 137, 184, 0.15);
  box-shadow: 0 5px 5px -2px rgba(0,0,0,.2);
}
.contain1 {
  padding-bottom:10px;
  background-color: rgba(193,66,66,0.3);
  box-shadow: 0 5px 5px -2px rgba(0,0,0,.2);
}
.contain2 {
  padding-bottom:10px;
  background-color: rgba(191,191,63,0.18);
  box-shadow: 0 5px 5px -2px rgba(0,0,0,.2);
}
.contain3 {
  padding-bottom:10px;
  background-color: rgba(63,63,191,0.1);
  box-shadow: 0 5px 5px -2px rgba(0,0,0,.2);
}*/

</style>